// @flow
import * as React from 'react'

import './styles.css'

type PropsType = {
  children: React.Node,
  action: () => void
}

export default class BigDate extends React.Component<PropsType> {
  render () {
    return (
      <div className="btn-container" onClick={() => this.props.action()}>
        <h4 className="photographer-name">{this.props.children}</h4>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Button/index.jsx